import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Button, Container, Grid, Typography, Hidden, Table, TableCell, TableBody, TableRow, TableHead, TableContainer } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { genfunction } from '../../helpers';
import {
    actionShopCartSetManageMyBooking, actionShopCartSetRefundType, actionShopCartSetMmbAmountToPay,
    actionShopCartResetMembership, actionShopCartResetIDME, actionShopCartSetEnteredAmountToPay, actionGetBookingTypes
} from 'actions';

import { actionResetBooking } from 'actions';


import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(5)
        }
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        padding: "5px"
    },
    image: {
        border: "5px solid white",
        padding: '10px',
        align: 'center'
    },
    warningMsg: {
        color: 'Red'
    },
    AdjustContext: {
        padding: '12px'
    },
    hideBtn: {
        display: 'none'
    },
    button: {
        marginLeft: "10px",
        height: '60px',
        display: 'inline-flex',
    },
    boxBorder:
    {
        border: '4px solid ' + theme.palette.primary.main,
        borderRadius: '2px'
    },

}));

const ManageMultipleBookings = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const reducerBooking = useSelector(state => state.reducerBooking);
    const transactionfee = useSelector(state => state.reducerTransactionFee);
    const cashless = useSelector(state => state.reducerShopCart.cashless);
    const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
    let cashlesstotal = cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0);

    useEffect(() => {

        if (bookingTypes == undefined || bookingTypes.length <= 0) {

            let bookingTypeIDList = reducerBooking.booking.map(b => b.BookingTypeID).join(',');

            if (bookingTypeIDList !== "" && bookingTypeIDList.trim().length > 0) {
                actionGetBookingTypes(dispatch, '', false, bookingTypeIDList.replace(/,*$/, ''));
            }
        }

    }, [])

    const totalBookingCost = (booking) => {
        let total = 0;
        if (booking && booking.hasOwnProperty('BookingProducts') && booking.BookingProducts.length > 0) {
            total = booking.BookingProducts.map(({ ProductLinePriceInclTax }) => ProductLinePriceInclTax).reduce((sum, i) => sum + i, 0);
        }

        return total;
    }


    const totalPaid = (booking) => {
        let total = 0;
        if (booking && booking.hasOwnProperty('BookingPayments') && booking.BookingPayments.length > 0) {
            total = booking.BookingPayments.map(({ PaymentAmount }) => PaymentAmount).reduce((sum, i) => sum + i, 0);
        }

        return total;
    }

    const totalPaidOfAllBookings = () => {

        return reducerBooking.booking.reduce((sumA, itemA) => {
            let totalB = itemA.hasOwnProperty('BookingPayments') && itemA.BookingPayments.length > 0 && itemA.BookingPayments.reduce((sumB, itemB) => sumB + itemB.PaymentAmount, 0);
            return sumA + totalB;

        }, 0)
    }

    const totalBalanceOwingOfAllBookings = () => {

        return reducerBooking.booking.reduce((sum, item) => {
            return sum + item.BalanceOwing
        }, 0)
    }

    const constredirecttofindmybpooking = () => {

        actionResetBooking(dispatch);
        actionShopCartSetManageMyBooking(dispatch, false, false);
        actionShopCartResetMembership(dispatch);
        actionShopCartResetIDME(dispatch);

        props.history.push({
            pathname: '/findmybooking'
        })

    }

    const reditecttocheckout = () => {

        let BalanceOwe = totalBalanceOwingOfAllBookings();
        // reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('BalanceOwing') && reducerBooking.booking[0].BalanceOwing > 0 ?
        //     reducerBooking.booking[0].BalanceOwing : 0;

        if (BalanceOwe > 0) {
            actionShopCartSetRefundType(dispatch, "AdditionalPayment");

            BalanceOwe = addTransFeeWithBalance(BalanceOwe);
            actionShopCartSetMmbAmountToPay(dispatch, BalanceOwe);

            props.history.push({
                pathname: '/managecheckout',
                refundType: 'AdditionalPayment',
            })
        }
    }

    const addTransFeeWithBalance = (balanceOwe) => {

        if (transactionfee.transactionFee && transactionfee.transactionFee.length > 0) {
            if (transactionfee.transactionFee[0].TransactionFeeByDefault) {
                let transFee = genfunction.TransactionFeeForPartialPayment(transactionfee.transactionFee[0], balanceOwe, cashlesstotal)

                if (transFee > 0) {
                    actionShopCartSetEnteredAmountToPay(dispatch, balanceOwe);
                    return genfunction.Rounded(balanceOwe + transFee);
                }
            }
        }
        return balanceOwe;
    }

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));

    return (
        <Container id="vt_page_manage_my_booking_multiple" className={classes.root} >
            <Grid
                container
                alignContent="center"
                // className={classes.boxBorder}
                align="center"
                xs={12} md={12}
                justify="center"
                style={{ margin: "0px auto" }}
            >
                <Grid item xs={12} md={7} style={{ padding: "15px" }} >
                    <Hidden smDown>
                        <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ padding: "5px" }}>
                            Payment Details
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h3" style={{ padding: "5px" }}>
                            Payment Details
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h4" style={{ padding: "7px" }}>
                            Payment Details
                        </Typography>
                    </Hidden>

                    <TableContainer component={Paper}>
                        <Table aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Booking ID</StyledTableCell>
                                    <StyledTableCell>Total Amount</StyledTableCell>
                                    <StyledTableCell>Amount Paid</StyledTableCell>
                                    <StyledTableCell>Amount Remaining</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reducerBooking.booking.map((booking) => (
                                    <StyledTableRow key={booking.BookingID} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <StyledTableCell component="th" scope="row">{booking.BookingID}</StyledTableCell>
                                        <StyledTableCell>{genfunction.ccyFormat(totalBookingCost(booking))}</StyledTableCell>
                                        <StyledTableCell>{genfunction.ccyFormat(totalPaid(booking))}</StyledTableCell>
                                        <StyledTableCell>{genfunction.ccyFormat(booking.BalanceOwing)}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>

                <Grid item xs={12} md={7} align="left" style={{ padding: "15px" }} >

                    <Hidden smDown>
                        <Typography variant="h5" className={classes.AdjustContext}>
                            Total Paid : {genfunction.ccyFormat(totalPaidOfAllBookings())}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Total Paid : {genfunction.ccyFormat(totalPaidOfAllBookings())}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Total Paid : {genfunction.ccyFormat(totalPaidOfAllBookings())}
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h5" className={classes.AdjustContext}>
                            Balance Owing : {genfunction.ccyFormat(totalBalanceOwingOfAllBookings())}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Balance Owing : {genfunction.ccyFormat(totalBalanceOwingOfAllBookings())}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" className={classes.AdjustContext}>
                            Balance Owing :{genfunction.ccyFormat(totalBalanceOwingOfAllBookings())}
                        </Typography>
                    </Hidden>

                </Grid>


                <Grid item xs={12} md={12} align="center" className={classes.AdjustContext}>
                    <Hidden smDown>

                        <Button variant="outlined" size="medium" color="primary"
                            className={classes.AdjustContext + " " + classes.button}
                            onClick={() => constredirecttofindmybpooking()}>
                            Cancel Changes
                        </Button>

                        <Button variant="contained" size="medium" color="primary"
                            className={reducerBooking.booking && reducerBooking.booking.every(i => i.BalanceOwing > 0) ? classes.AdjustContext + " " + classes.button : classes.hideBtn}
                            onClick={() => reditecttocheckout()}>
                            Make Payment <br /> ({genfunction.ccyFormat(totalBalanceOwingOfAllBookings())})
                        </Button>
                    </Hidden>

                    <Hidden xsDown mdUp>

                        <Button variant="outlined" size="small" color="primary"
                            className={classes.AdjustContext + " " + classes.button}
                            onClick={() => constredirecttofindmybpooking()}>
                            Cancel Changes
                        </Button>

                        <Button variant="contained" size="small" color="primary"
                            className={reducerBooking.booking && reducerBooking.booking.every(i => i.BalanceOwing > 0) ? classes.AdjustContext + " " + classes.button : classes.hideBtn}
                            onClick={() => reditecttocheckout()}>
                            Make Payment <br /> ({genfunction.ccyFormat(totalBalanceOwingOfAllBookings())})
                        </Button>
                    </Hidden>

                    <Hidden smUp>
                        <Button variant="outlined" size="small" color="primary"
                            className={classes.AdjustContext + " " + classes.button}
                            onClick={() => constredirecttofindmybpooking()}>
                            Cancel Changes
                        </Button>

                        <Button variant="contained" size="small" color="primary"
                            className={reducerBooking.booking && reducerBooking.booking.every(i => i.BalanceOwing > 0) ? classes.AdjustContext + " " + classes.button : classes.hideBtn}
                            onClick={() => reditecttocheckout()}>
                            Make Payment <br /> ({genfunction.ccyFormat(totalBalanceOwingOfAllBookings())})
                        </Button>
                    </Hidden>
                </Grid>
            </Grid>
        </Container>
    )
}

export default ManageMultipleBookings;

